import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Modal, Paper, IconButton, Typography, Stack, Button, Box } from '@mui/material';
import { MdClose } from 'react-icons/md';
import { useBookMyOpAuth } from '../contexts/BookMyOpAuthContext';
import SearchSection from './Home/SearchSection';
import MobileBottomNav from '../components/MobileBottomNav';
import { useTheme } from '../contexts/ThemeContext';
import EasyOPSwitchButton from '../components/EasyOPSwitchButton';
const MobileLayout = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { isAuthenticated } = useBookMyOpAuth();
  const { theme } = useTheme();
  const handleSignUpClick = () => {
    setShowAuthModal(true);
  };

  const handleModalClose = () => {
    setShowAuthModal(false);
  };

  const handleLoginClick = () => {
    setShowAuthModal(false);
    navigate('/login');
  };

  return (
    <>
      {/* Top Section - SearchSection */}
      <Box sx={{ 
        position: 'fixed', 
        top: 0, 
        left: 0, 
        right: 0, 
        zIndex: 1000,
        backgroundColor: 'background.default',
        borderBottom: '1px solid',
        borderColor: 'divider'
      }}>
        <SearchSection />
      </Box>

      {/* Main Content Area */}
      <Box sx={{ 
        pt: { xs: '110px', sm: '160px' }, // Adjust based on SearchSection height
        pb: { xs: '100px', sm: '120px' }, // Adjust based on MobileBottomNav height (84px + safe area)
        minHeight: 'calc(100vh - 240px)', // Account for top and bottom sections
        overflow: 'auto',
        bgcolor:`${theme.palette.background.paper}`,

      }}>
        <Outlet />
      </Box>

      {/* Bottom Section - MobileBottomNav */}
      <MobileBottomNav onAuthClick={handleSignUpClick} />

      {/* Auth Modal */}
      <Modal
        open={showAuthModal && !isAuthenticated}
        onClose={handleModalClose}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Paper sx={{ 
          position: 'relative',
          width: '90%',
          maxWidth: 400,
          p: 4,
          borderRadius: 2
        }}>
          <IconButton
            onClick={handleModalClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8
            }}
          >
            <MdClose />
          </IconButton>
          <Typography variant="h5" textAlign="center" mb={3}>
            Welcome to BookMyOP
          </Typography>
          <Stack spacing={2}>
            <Button variant="contained" fullWidth onClick={handleLoginClick}>
              Login
            </Button>
          </Stack>
        </Paper>
      </Modal>
    </>
  );
};

export default MobileLayout;
